<template>
  <!-- 精准教学 -->
  <div class="jingzhunjiaoxue">
    <PublicCert :logo="Logo4" :type="'jzjx'" :color="'#159b7b'" />
  </div>
</template>

<script>
import PublicCert from '../component/certQuery.vue'
import Logo4 from '@/assets/images/logo4.png'

export default {
  name: 'JingZhunJiaoXue',
  components: {
    PublicCert
  },
  data() {
    return {
      Logo4
    }
  }
}
</script>
